import ProjectItemPersonalArea from './ProjectItemPersonalArea';

export default ProjectItemPersonalArea;
